import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';

/**
 * Map 渲染器 - 简单映射渲染
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 */
const MapRenderer = ({ params, config }) => {
  let _params = params;

  if (config.firstField) {
    if (typeof config.firstField === 'string') {
      _params = params[config.firstField];
    } else {
      const key = config.firstField.filter(i => _params[i])?.[0] || '';
      _params = _params[key];
    }
  }

  return (
    <>
      {_params && Object.keys(_params)?.filter(i => {
        return Object.keys(config.fieldsMap)?.includes(i);
      })?.map((key, index) => (
        <Fragment key={`map-${index}`}>
          {_params[key] && (
            <Form.Item label={config.fieldsMap[key]}>
              {_params[key]}
            </Form.Item>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default MapRenderer;
